import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b500a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video_merge" }
const _hoisted_2 = { class: "container_warn" }
const _hoisted_3 = { class: "flex between video_title" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "视频名称：", -1))
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "视频总长度：", -1))
const _hoisted_8 = { class: "primary" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "img_box" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "item_title" }
const _hoisted_13 = { style: {"margin-bottom":"10px"} }
const _hoisted_14 = { class: "flex center footer" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://images.innocomn.com/c3a4f202109221415107169.gif" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "listBox" }
const _hoisted_19 = { class: "listTop flex between" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { style: {"margin-left":"20px","width":"200px"} }
const _hoisted_22 = { style: {"color":"#00ccb0"} }
const _hoisted_23 = { class: "top_right" }
const _hoisted_24 = {
  key: 0,
  style: {"height":"500px"}
}
const _hoisted_25 = {
  key: 1,
  style: {"height":"500px","text-align":"center","width":"100%","line-height":"400px"}
}
const _hoisted_26 = {
  key: 2,
  class: "listBottom flex between",
  "infinite-scroll-disabled": "false",
  "infinite-scroll-distance": "20"
}
const _hoisted_27 = { class: "b_box" }
const _hoisted_28 = { class: "checkbox" }
const _hoisted_29 = ["value", "onChange"]
const _hoisted_30 = { class: "b_left" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "b_right" }
const _hoisted_34 = { class: "created_time" }
const _hoisted_35 = {
  class: "loading",
  style: {"height":"20px","line-height":"50px","width":"900px","text-align":"center"}
}
const _hoisted_36 = { key: 0 }

import { ref, nextTick, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons-vue';
import { Alert, Modal, Input, message } from 'ant-design-vue';
import { VueDraggableNext } from 'vue-draggable-next';
import http from '@/api/playback';
import { emptyDataSec } from '@/assets';
import CLoading from '@/components/CLoading.vue';
import https from '@/api/media';
import { dragDrop } from '@/utils/format/dragDrop';

interface videoInfo {
  id: number;
  cover_url: string;
  created_at: string;
  duration: string;
  format: string;
  size: string;
  title: string;
  video_id: string;
  video_url: string;
}
interface idtype {
  id: number;
}
interface livedatas {
  cover_url: string;
  duration: string;
  id: number;
  code: number;
  title: string;
  created_at: string;
  resolution: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoMerge',
  setup(__props) {

const draggable = VueDraggableNext;
const aAlert = Alert;
const aModal = Modal;
const aInputSearch = Input.Search;
const route = useRoute();
const router = useRouter();
const dataInfo = ref({
  project_title: '',
  duration: 0,
});
//视频列表拖拽事件
const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});
// 时间转化
const timeTranslate = (t: number) => {
  // 时间转化
  let hr: any = Math.floor((t / 3600) % 24);
  if (hr < 10) {
    hr = '0' + Math.floor((t / 3600) % 24);
  }
  let m: any = Math.floor((t / 60) % 60);
  m < 10 && (m = '0' + m);
  return hr + ':' + m + ':' + ((t % 60) / 100).toFixed(2).slice(-2);
};
const videoList = ref<videoInfo[]>([]);

const getVideosInfo = (ids: any) => {
  let params = {
    ids: ids ? ids : route.query.ids,
  };
  https.getVideosInfo({ params }).then((res) => {
    videoList.value.push(...res.data.data);
    changeDuration();
    nextTick(() => {
      !ids && Mplayer(videoList.value[0]);
      !ids && changeEnden();
    });
  });
};
getVideosInfo(0);

const changeDuration = () => {
  dataInfo.value.duration = 0;
  videoList.value.forEach((item: any) => {
    dataInfo.value.duration += Number(item.duration);
  });
};
const delVideoItem = (index: number) => {
  videoList.value.splice(index, 1);
  changeDuration();
};
const videoshake = ref<boolean>(false);
const save = () => {
  if (videoshake.value) {
    return;
  }
  videoshake.value = true;
  let arr: any = [];
  videoList.value.forEach((element) => {
    arr.push(element.id);
  });
  let params = {
    name: dataInfo.value.project_title,
    ids: arr.join(','),
  };
  https
    .aliyunVideoMerge(params)
    .then((res) => {
      message.success(res.data.message);
      router.push('/media/videos');
    })
    .catch((res) => {
      videoshake.value = false;
      message.error(res.data.error);
    });
};
//实例化播放器
const videoRef = ref();
const videoPlayer = ref();
// const media = ref();
const videoIndex = ref(0);
const Mplayer = (player_data: any) => {
  videoPlayer.value = new window.videojs(videoRef.value, {
    playbackRates: [0.5, 0.75, 1, 1.5, 2], //播放速度
    language: 'zh-CN',
    notSupportedMessage: '此视频暂时无法播放,请稍后再试',
    controls: true,
    techOrder: ['html5'], //html5模式
    fluid: true, //流式布局,适应父元素大小
    aspectRatio: '16:9', //流式布局时，自适应大小的比例
    preload: true, //预加载
    autoplay: true, //是否自动播放
    poster: player_data.cover_url,
    loop: videoList.value.length > 1 ? false : true,
  });
  videoPlayer.value.src({
    src: player_data.video_url,
  });
};
const changeEnden = () => {
  videoPlayer.value.on('ended', () => {
    if (videoPlayer.value) {
      // videoPlayer.value.dispose(); //销毁播放器
    }
    videoIndex.value++;
    if (videoIndex.value > videoList.value.length - 1) {
      videoIndex.value = 0;
    }
    setTimeout(() => {
      Mplayer(videoList.value[videoIndex.value]);
      // changeEnden();
    });
  });
};
onUnmounted(() => {
  videoPlayer.value.dispose();
});

//选择视频添加
const videochecked = ref<idtype[]>([]); //选择视频放入数组
let loadpage_total = ref<any>(0); //视频总条数
const checkChange = (id: any) => {
  videochecked.value.push(id);
};

const loadpage_size = ref(1); //第几页数据
const last_page = ref(0); //最后一页数据
const noMore = ref(false); //判断是否有更多数据
const showLoading = ref<boolean>(false);
const visible = ref<boolean>(false);
const addPlayList = ref<livedatas[]>([]);
const addListVideo = () => {
  videochecked.value = [];
  addPlayList.value = [];
  loadpage_size.value = 1;
  visible.value = true;
  getCurrent(1, videoKeyword.value);
};
//获取视频列表
const getCurrent = (current: any, keywords: any) => {
  let data = {
    keywords: keywords,
    page: current,
    page_num: 10,
  };
  showLoading.value = true;
  http
    .getVideoList({ params: data })
    .then((res: any) => {
      showLoading.value = false;
      if (res.data.code == 200) {
        addPlayList.value.push(...res.data.data.data);
        loadpage_total.value = res.data.data.total;
        last_page.value = res.data.data.last_page;
      }
    })
    .catch(() => {
      showLoading.value = false;
    });
};
//滚动加载数据
const getChildList = () => {
  if (loadpage_size.value >= last_page.value) {
    noMore.value = true;
  } else {
    noMore.value = false;
    loadpage_size.value++;
    getCurrent(loadpage_size.value, videoKeyword.value);
  }
};
//搜索视频关键字
const videoKeyword = ref();
const videoSearch = () => {
  addPlayList.value = [];
  getCurrent(1, videoKeyword.value);
};
//点击整个模块勾选
const checked = (e: any) => {
  e.currentTarget.previousElementSibling.firstElementChild.click();
};
//勾选完视频确认按钮
const handleOk = () => {
  visible.value = false;
  let res = addPlayList.value.filter((i: any) => videochecked.value.includes(i.id));
  let arr: any = ref([]);
  res.forEach((element) => {
    arr.value.push(element.id);
  });
  getVideosInfo(arr.value.join(','));
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(aAlert), {
        type: "warning",
        class: "warn_content",
        message: "推荐使用相同来源视频合并，避免因视频格式不兼容导致视频无法播放，保存将另存为一个新视频，不会覆盖原有视频。",
        banner: "",
        closable: ""
      })
    ]),
    (videoList.value.length != 0)
      ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          ref_key: "videoRef",
          ref: videoRef,
          id: "videojs-player",
          controls: "",
          class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered"
        }, null, 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_a_input, {
          type: "text",
          value: dataInfo.value.project_title,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataInfo.value.project_title) = $event)),
          style: {"width":"330px"}
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(timeTranslate(dataInfo.value.duration)), 1),
        _createVNode(_component_a_button, {
          class: "add_video",
          onClick: addListVideo
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(PlusOutlined))
          ]),
          default: _withCtx(() => [
            _createTextVNode("添加视频 ")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_unref(draggable), _mergeProps({
      class: "video_list flex between",
      list: videoList.value
    }, dragOptions.value, {
      handle: ".mover",
      options: { animation: 500 },
      onDrop: _unref(dragDrop)
    }), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "video_item flex between",
            key: index
          }, [
            _createElementVNode("div", null, [
              (index < 9)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "0"))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(index + 1), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: item.cover_url
              }, null, 8, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", null, _toDisplayString(item.title), 1),
              _createElementVNode("p", null, _toDisplayString(timeTranslate(Number(item.duration))), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_13, [
                _createVNode(_component_svg_icon, {
                  class: "mover",
                  "icon-class": "drag_icon"
                })
              ]),
              _withDirectives(_createVNode(_component_svg_icon, {
                class: "mod_btn_icon",
                "icon-class": "del",
                onClick: ($event: any) => (delVideoItem(index))
              }, null, 8, ["onClick"]), [
                [_vShow, videoList.value.length > 2]
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 16, ["list", "onDrop"]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(aModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
      centered: "",
      title: "添加视频",
      onOk: handleOk,
      width: "910px"
    }, {
      default: _withCtx(() => [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(aInputSearch), {
                class: "mod_range_picker_search margin-b",
                value: videoKeyword.value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((videoKeyword).value = $event)),
                placeholder: "请输入关键字",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (videoSearch()))
              }, {
                enterButton: _withCtx(() => [
                  _createVNode(_unref(SearchOutlined))
                ]),
                _: 1
              }, 8, ["value"]),
              _createElementVNode("span", _hoisted_21, [
                _createTextVNode("视频数量："),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(loadpage_total)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_router_link, {
                to: { path: `/media` },
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, null, {
                    default: _withCtx(() => [
                      _createTextVNode("去上传")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          (showLoading.value && addPlayList.value.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(CLoading)
              ]))
            : (addPlayList.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_a_empty, {
                    class: "empty_wrap",
                    image: _unref(emptyDataSec),
                    description: "页面暂无数据信息~"
                  }, null, 8, ["image"])
                ]))
              : _createCommentVNode("", true),
          (addPlayList.value.length != 0)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addPlayList.value, (i, j) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item-box",
                    key: j
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          value: videochecked.value,
                          onChange: ($event: any) => (checkChange(i.id))
                        }, null, 40, _hoisted_29)
                      ]),
                      _createElementVNode("div", {
                        class: "b_content",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (checked($event)))
                      }, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("img", {
                            src: i.cover_url
                          }, null, 8, _hoisted_31),
                          _createElementVNode("span", null, _toDisplayString(i.duration), 1),
                          (i.code == 207)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, "视频转码失败！"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("h2", null, _toDisplayString(i.title), 1),
                          _createElementVNode("p", _hoisted_34, [
                            _createTextVNode(" 上传时间："),
                            _createElementVNode("span", null, _toDisplayString(i.created_at), 1)
                          ]),
                          _createElementVNode("p", null, "分辨率：" + _toDisplayString(i.resolution), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_35, [
                  (noMore.value && addPlayList.value.length > 9)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_36, "没有更多了"))
                    : _createCommentVNode("", true)
                ])
              ])), [
                [_directive_infinite_scroll, getChildList]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})